export const PROJECTS = [
  {
    title: "Oxford & Young St",
    id: "Oxford-&-Young-St",
    image: "oxford-young-1.webp",
    tags: ["Windows & Doors Installation", "Architectural Cladding & Siding"],
    status: "Completed",
  },
    {
    title: "Bayers & Young",
    id: "Bayers-&-Young",
    image: "bayers-young-1.webp",
    tags: ["Fiber Cement Cladding", "Architectural Tile Cladding"],
    status: "Completed",
  },
  {
    title: "Chain Lake",
    id: "chain-lake",
    image: "chain-lake-1.webp",
    tags: ["Curtain wall", "ACM Composite"],
    status: "Completed",
  },
  {
    title: "Wedgewood",
    id: "wedgewood",
    image: "wedgewood-1.webp",
    tags: ["Architectural Glazing & Curtain Walls", "Aluminum Composite Cladding"],
    status: "Completed",
  },
];

export const PROJECT_DETAILS = [
  {
    id: "Oxford-&-Young-St",
    title: "Oxford & Young St",
    location: "6419 Young St, Halifax, NS B3L 2A4",
    status: "Completed",
    images: ["oxford-young-1.webp", "oxford-young-2.webp", "oxford-young-3.webp"],
    info: [
      /* { label: "Clients", value: "AG Property Holdings Ltd", icon: "users" }, */
      { label: "Scope", value: "Membering, Vinyl Windows & Doors, HF12 Siding, Mac Metal Siding, Tempio Tile", icon: "wrench" },
/*      { label: "Size", value: "18,000 sf.", icon: "ruler" },*/
      { label: "Completion", value: "2026", icon: "calendar" },
    ],
  },
  {
    id: "Bayers-&-Young",
    title: "Bayers & Young",
    /*location: "6419 Young St, Halifax, NS B3L 2A4",*/
    status: "Completed",
    images: ["bayers-young-1.webp", "bayers-young-2.webp", "bayers-young-3.webp"],
    info: [
      /* { label: "Clients", value: "AG Property Holdings Ltd", icon: "users" }, */
      { label: "Scope", value: "James Hardie Board, Fiber Cement, Tempio Tile", icon: "wrench" },
/*      { label: "Size", value: "18,000 sf.", icon: "ruler" },*/
      { label: "Completion", value: "2023", icon: "calendar" },
    ],
  },
  {
    id: "chain-lake",
    title: "Chain Lake",
    /*location: "138 Chain Lake Dr, Halifax, NS B3S 1B8",*/
    status: "Completed",
    images: ["chain-lake-1.webp", "chain-lake-2.webp", "chain-lake-3.webp"],
    info: [
     /* { label: "Clients", value: "Alumitech Ltd", icon: "users" },*/
      { label: "Scope", value: "Curtain wall and ACM composite panel.", icon: "wrench" },
     /* { label: "Size", value: "18,000 sf.", icon: "ruler" },*/
      { label: "Completion", value: "2026", icon: "calendar" },
    ],
  },
  {
    id: "wedgewood",
    title: "Wedgewood",
    location: "10 Kearney Lake Rd, Halifax, NS B3M 0B8",
    status: "Completed",
    images: ["wedgewood-1.webp", "wedgewood-2.webp", "wedgewood-3.webp"],
    info: [
      /* { label: "Clients", value: "", icon: "users" }, */
      { label: "Scope", value: "Glazing, Curtain wall, ACM composite panel", icon: "wrench" },
     /* { label: "Size", value: "", icon: "ruler" },*/
      { label: "Completion", value: "2026", icon: "calendar" },
    ],
  },
];
